import React, { Component } from 'react';

class CartLineItem extends Component {
  increaseQuantity = () => {
    this.props.updateLineQuantity(this.props.product.variant_id, this.props.product.quantity + 1);
  };

  decreaseQuantity = () => {
    this.props.updateLineQuantity(this.props.product.variant_id, this.props.product.quantity - 1);
  };

  removeProduct = () => {
    this.props.updateLineQuantity(this.props.product.variant_id, 0);
  };

  renderProperties = () => {
    const properties = this.props.product.properties
    
    let val, frequency, frequency_unit

    if (properties != undefined) {
      for(let prop in this.props.product.properties){
        if(prop == 'shipping_interval_frequency'){
          frequency = properties[prop];
        } 
        if(prop == 'shipping_interval_unit_type'){
          if (frequency == '1'){
            if(properties[prop] == "Days"){
              frequency_unit = "Day"
            } else if (properties[prop] == "Months"){
              frequency_unit = "Month"
            } else if (properties[prop] == "Weeks"){
              frequency_unit = "Week"
            } 
          } else {
            frequency_unit = properties[prop] 
          }
        }
        if(frequency && frequency_unit){
          val = frequency + ' ' + frequency_unit;
        } else {
          val = properties[prop]
        }
      }
    }
    return <span>{val}</span>
  }

  render() {
    const product = this.props.product;
    return (
      <div className="Card Card--product">
        <figure className="Card__figure">
          {product.image &&
            <a href={product.url}>
              <img src={product.image} alt={product.product_title} />
            </a>
          }
          
        </figure>
        <div className="Card__details">
          <h6 className="Card__title">
            <a href={product.url}>
              {product.product_title} {product.variant_title && <small>{product.variant_title}</small>}
            </a>
            <p className="properties">{this.renderProperties()}</p>
          </h6>
          <div className="quantity_and_amount">
            <div className="quantity">
              <button onClick={this.decreaseQuantity}>-</button>
              <span className="value">{product.quantity}</span>
              <button onClick={this.increaseQuantity}>+</button>
            </div>
            <div className="amount">${(product.line_price / 100).toFixed(2)}</div>
            {/* <button className="Button delete-line" data-style="noStyle" onClick={this.removeProduct}>&times;</button> */}
          </div>
        </div>
      </div>
    );
  }
}

export default CartLineItem;
